<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import { ZmsFb } from "@core/utils/ZmsFb.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./WhereYouCanFindUs.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
</script>

<section class="full-width grid-container bg-zms-grey">
	<div class="flex w-full justify-start md:justify-center mb-8 sm:mb-10 md:mb-16 lg:mb-24">
		<h2 class="text-left md:text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
			<Formatted text={translate("heading")} />
		</h2>
	</div>
	<div class="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-6 lg:gap-20">
		<div class="flex flex-col gap-2 lg:gap-6">
			<div
				class="flex flex-col gap-4 sm:gap-6 md:gap-8 border-t border-zms-blue px-4 sm:px-6 py-6 sm:py-8 md:py-10 bg-zms-grey"
			>
				<h3 class="text-zms-blue-dark text-lg sm:text-2xl md:text-[2rem]/[1.2] font-semibold">
					<Formatted text={translate("companyInfoHeading")} />
				</h3>
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-6">
					<span class="text-base sm:text-lg md:text-[1.125rem]/[1] font-semibold"
						><Formatted text={translate("companyName")} /></span
					>
					<table class="text-zms-optical-black">
						<tbody class="flex flex-col gap-2 sm:gap-4 md:gap-6">
							<tr class="flex items-start">
								<td class="w-16 sm:w-20 md:w-[5.5rem] text-xs sm:text-sm/[1]"
									><Formatted text={translate("addressLabel")} /></td
								>
								<td class="text-xs sm:text-sm/[1.5] font-semibold"><Formatted text={translate("address")} /></td>
							</tr>
							<tr>
								<td class="w-16 sm:w-20 md:w-[5.5rem] text-xs sm:text-sm/[1]"
									><Formatted text={translate("companyIdLabel")} /></td
								>
								<td class="text-xs sm:text-sm/[1] font-semibold"><Formatted text={translate("companyId")} /></td>
							</tr>
							<tr>
								<td class="w-16 sm:w-20 md:w-[5.5rem] text-xs sm:text-sm/[1]"
									><Formatted text={translate("vatIdLabel")} /></td
								>
								<td class="text-xs sm:text-sm/[1] font-semibold"><Formatted text={translate("vatId")} /></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div
				class="flex flex-col gap-4 sm:gap-6 md:gap-8 border-t border-zms-blue px-4 sm:px-6 py-6 sm:py-8 md:py-10 bg-zms-grey"
			>
				<h3 class="text-zms-blue-dark text-lg sm:text-2xl md:text-[2rem]/[1.2] font-semibold">
					<Formatted text={translate("contactInfoHeading")} />
				</h3>
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-6">
					<span class="text-base sm:text-lg md:text-[1.125rem]/[1] font-semibold"
						><Formatted text={translate("companyName")} /></span
					>
					<table class="text-zms-optical-black">
						<tbody class="flex flex-col gap-4 sm:gap-5 md:gap-6">
							<tr>
								<td class="w-16 sm:w-20 md:w-[5.5rem] text-xs sm:text-sm/[1]"
									><Formatted text={translate("phoneLabel")} /></td
								>
								<td class="text-xs sm:text-sm/[1] font-semibold"
									><Link href="tel:+420603722624"><Formatted text={translate("phone")} /></Link></td
								>
							</tr>
							<tr>
								<td class="w-16 sm:w-20 md:w-[5.5rem] text-xs sm:text-sm/[1]"
									><Formatted text={translate("emailLabel")} /></td
								>
								<td class="text-xs sm:text-sm/[1] font-semibold"
									><Link href="mailto:martin.turon@zmservis-moravia.cz"><Formatted text={translate("email")} /></Link
									></td
								>
							</tr>
							<tr>
								<td class="w-16 sm:w-20 md:w-[5.5rem] text-xs sm:text-sm/[1]"
									><Formatted text={translate("facebookLabel")} /></td
								>
								<td class="text-xs sm:text-sm/[1] font-semibold">
									<Link href={ZmsFb} target="_blank">facebook.com/zmservismoravia</Link>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="border rounded-2xl overflow-hidden">
			<iframe
				class="w-full h-64 sm:h-80 md:h-96 lg:h-full overflow-hidden"
				title="map"
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9125.9206175721571!2d18.64068130142862!3d49.670700443338625!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4714057a55555555%3A0xbe1f1bae57b4e3e6!2sZM%20SERVIS%20MORAVIA%2C%20s.r.o.!5e0!3m2!1scs!2scz!4v1752746025567!5m2!1scs!2scz"
				width="620"
				height="620"
				style="border:0;"
				loading="lazy"
				referrerpolicy="no-referrer-when-downgrade"
			></iframe>
		</div>
	</div>
</section>
